import React from 'react';
import {
  GalleryContainer,
  GalleryWhiteWrapper,
  GalleryWrapper,
  IconDetailsHeader,
  IconDetailWrapper,
  IconImage,
  IconText,
  GalleryGridWrapper,
  IconHeader,
} from './iconDetailsElements';

// Icons
import iconWaterfall from '../../../Images/GalleryIcons/iconWaterfall.png';
import iconCave from '../../../Images/GalleryIcons/iconCave.png';
import iconVegetation from '../../../Images/GalleryIcons/iconVegetation.png';
import iconAnimals from '../../../Images/GalleryIcons/iconAnimals.png';
import iconSocial from '../../../Images/GalleryIcons/iconSocial.png';
import iconTourism from '../../../Images/GalleryIcons/iconTourism.png';
import iconVista from '../../../Images/GalleryIcons/iconVista.png';
import iconNatural from '../../../Images/GalleryIcons/iconNatural.png';

const index = () => (
  <GalleryContainer>
    <GalleryWrapper>
      <GalleryWhiteWrapper>
        <IconDetailsHeader>Icon Details</IconDetailsHeader>
        <GalleryGridWrapper>
          <IconDetailWrapper>
            <IconImage alt="icon" src={iconWaterfall} />
            <IconHeader>Waterfall</IconHeader>
            <IconText>dasdasdasdasdasd asda dasd asdas asdasd</IconText>
          </IconDetailWrapper>
          <IconDetailWrapper>
            <IconImage alt="icon" src={iconCave} />
            <IconHeader>Cave</IconHeader>
            <IconText>dasdasdasdasdasd asda dasd asdas asdasd</IconText>
          </IconDetailWrapper>
          <IconDetailWrapper>
            <IconImage alt="icon" src={iconVegetation} />
            <IconHeader>Vegetation</IconHeader>
            <IconText>dasdasdasdasdasd asda dasd asdas asdasd</IconText>
          </IconDetailWrapper>
          <IconDetailWrapper>
            <IconImage alt="icon" src={iconAnimals} />
            <IconHeader>Animals</IconHeader>
            <IconText>dasdasdasdasdasd asda dasd asdas asdasd</IconText>
          </IconDetailWrapper>
          <IconDetailWrapper>
            <IconImage alt="icon" src={iconVista} />
            <IconHeader>Vista</IconHeader>
            <IconText>dasdasdasdasdasd asda dasd asdas asdasd</IconText>
          </IconDetailWrapper>
          <IconDetailWrapper>
            <IconImage alt="icon" src={iconSocial} />
            <IconHeader>Social</IconHeader>
            <IconText>dasdasdasdasdasd asda dasd asdas asdasd</IconText>
          </IconDetailWrapper>
          <IconDetailWrapper>
            <IconImage alt="icon" src={iconTourism} />
            <IconHeader>Tourism</IconHeader>
            <IconText>dasdasdasdasdasd asda dasd asdas asdasd</IconText>
          </IconDetailWrapper>
          <IconDetailWrapper>
            <IconImage alt="icon" src={iconNatural} />
            <IconHeader>Natural Resources</IconHeader>
            <IconText>dasdasdasdasdasd asda dasd asdas asdasd</IconText>
          </IconDetailWrapper>
        </GalleryGridWrapper>
      </GalleryWhiteWrapper>
    </GalleryWrapper>
  </GalleryContainer>
);

export default index;
